const voiceItems = {
  VoiceTransferirRamalInternoExterno: {
    title: 'Transf. Ramal',
    icon: 'icon_ramal',
  },
  VoiceTTSAudio: {
    title: 'Tocar Áudio',
    icon: 'icon_asr',
  },
  VoiceConfirmarVenda: {
    title: 'Venda',
    icon: 'icon_carrinho',
  },
  VoiceTTSAudioASR: {
    title: 'Áudio + Reconhecimento de Voz',
    icon: 'icon_asr',
  },
  VoiceFinalizarAtendimento: {
    title: 'Finalizar Atendimento',
    icon: 'icon_email',
  },
  VoiceTransferirRamalLocalizadorVendedor: {
    title: 'Transf. Operador',
    icon: 'icon_humano',
  },
  VoiceAgendarMailing: {
    title: 'Agendar Ligação',
    icon: 'icon_agendar',
  },
  VoiceTTSAudioDTMF: {
    title: 'Áudio + Reconhecimento Dígitos',
    icon: 'icon_dtmf',
  },
  VoiceWebservice: {
    title: 'Webservice',
    icon: 'icon_webservice',
  },
  VoiceSMS: {
    title: 'Enviar SMS',
    icon: 'icon_sms',
  },
  VoicePesquisarMailing: {
    title: 'Pesquisar',
    icon: 'icon_formulario',
  },
  VoiceInserirMailing: {
    title: 'Inserir Mailing',
    icon: 'icon_email',
  },
  VoiceEmail: {
    title: 'Email',
    icon: 'icon_email',
  },

  VoicePularStep: {
    title: 'Pular STEP',
    icon: 'icon_pulo_step',
  },
};

export { voiceItems };
